<footer class="footer-text" role="contentinfo">
    <div class="footer-content">
    <div class="footer-line-left">
        <p>{{ footerConstants.footerText }} &copy; {{ currentYear }} {{ footerConstants.allRightsText }}</p>
    </div>
    <div class="footer-line-right">
        <p> {{ footerConstants.supportLabel }}<a href="mailto:!DT-IOP@cbre.com">{{ footerConstants.supportEmailLabel }}</a> {{ footerConstants.endLabel }}</p>
    </div>
    </div>
</footer>
